// Hex → name map mirrors the BE table at
// `FacebookDynamicCatalogIntegrationService::getColor()` — keep in sync.
export function colorHexToName(hex: string | null | undefined): string | null {
  if (!hex) { return null; }
  const raw = hex.trim();
  if (raw.toLowerCase() === 'multi') { return $localize`:vehicle colour:Večbarvno`; }
  const key = raw.toUpperCase();
  if (!key.startsWith('#')) { return hex; }

  const labels: Record<string, string> = {
    '#FFFFFF': $localize`:vehicle colour:Bela`,
    '#F5F5DC': $localize`:vehicle colour:Bež`,
    '#FFFDD0': $localize`:vehicle colour:Kremno bež`,
    '#C0C0C0': $localize`:vehicle colour:Srebrna`,
    '#A6A6A6': $localize`:vehicle colour:Svetlo siva`,
    '#808080': $localize`:vehicle colour:Siva`,
    '#595959': $localize`:vehicle colour:Temno siva`,
    '#000000': $localize`:vehicle colour:Črna`,
    '#FF0000': $localize`:vehicle colour:Rdeča`,
    '#990000': $localize`:vehicle colour:Bordo rdeča`,
    '#FFFF00': $localize`:vehicle colour:Rumena`,
    '#FF9900': $localize`:vehicle colour:Oranžna`,
    '#00822F': $localize`:vehicle colour:Olivno zelena`,
    '#67FF79': $localize`:vehicle colour:Svetlo zelena`,
    '#00FFB2': $localize`:vehicle colour:Modrozelena`,
    '#00FF00': $localize`:vehicle colour:Zelena`,
    '#006400': $localize`:vehicle colour:Temno zelena`,
    '#48D8FF': $localize`:vehicle colour:Svetlo modra`,
    '#0000FF': $localize`:vehicle colour:Modra`,
    '#00008B': $localize`:vehicle colour:Temno modra`,
    '#FFB6C1': $localize`:vehicle colour:Svetlo roza`,
    '#663399': $localize`:vehicle colour:Vijolična`,
    '#FFD700': $localize`:vehicle colour:Zlata`,
    '#8B4513': $localize`:vehicle colour:Rjava`,
    '#654321': $localize`:vehicle colour:Temno rjava`,
    '#B5651D': $localize`:vehicle colour:Svetlo rjava`,
  };

  return labels[key] ?? null;
}
